import React from "react";

interface CustomCheckboxProps {
  name: string;
  checked: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}

const CustomCheckbox = ({
  name,
  checked,
  handleChange,
  label,
}: CustomCheckboxProps) => {
  return (
    <div>
      <label
        htmlFor={name}
        className="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer"
      >
        <div
          className={`tw:h-5 tw:w-5 tw:rounded tw:border-1 tw:flex tw:items-center tw:justify-center tw:transition-colors ${
            checked
              ? "tw:bg-primary tw:border-primary"
              : "tw:bg-white tw:border-gray-300"
          }`}
        >
          {checked && (
            <svg
              className="tw:w-4 tw:h-4 tw:text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="butt"
              strokeLinejoin="miter"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>
        <span className="tw:text-sm tw:select-none">{label}</span>
      </label>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={handleChange}
        className="tw:hidden"
      />
    </div>
  );
};

export default CustomCheckbox;
